import {inject, Injectable, signal} from '@angular/core';
import {MatomoTracker} from "ngx-matomo-client";

@Injectable({
  providedIn: 'root'
})
export class EventTrackerService {

  private tracker = inject(MatomoTracker);
  private matomoSiteId = signal<number|undefined>(undefined);

  setMatomoSiteId(matomoSiteId: number) { this.matomoSiteId.set(matomoSiteId) }

  trackEvent(category: string, action: string, name?: string){
    this.tracker.trackEvent(category, action, name, this.matomoSiteId());
  }
}
